export default __webpack_public_path__ + "static/vimium_fF-1ffe0ce226ee5a9754117ae9a0413e5c.png";